import type { TreeMapCustomTooltipProps } from '../types/treemap-chart.config.js';

export const Tooltip = (props: TreeMapCustomTooltipProps) => null;

Tooltip['displayName'] = 'TreeMap.Tooltip';
